/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { Field } from 'redux-form'
import { MAX_LENGTHS, BUSINESS_FIELD_NAMES } from 'constants/forms'
import { Text, GetTextPath } from 'hocs/localization'
import { Input } from 'apps/FormFields'
import Button from 'elements/Button'
import {
  createValidation,
  createValidator,
  hasRequired,
  hasName,
  removeSpaces,
} from 'utils/form'
import * as styles from './BusinessDetailsForm.scss'

const cx = classNames.bind(styles)

interface IState {
  isDisabled: boolean,
}

interface IProps {
  isDisabled?: boolean,
  t: Text,
  getTextPath: GetTextPath,
  handleSubmit: any,
  submitting: boolean,
  valid: boolean,
  dirty: boolean,
  isView: boolean,
  stateOptions: any[],
  onChangeCountry: () => void,
  isCardUpdate: boolean,
  paymentInfoUrl: string,
  isEdit: boolean,
  onConfirmCorrectedAddress: () => void,
  isUserUnableToUpdateInfo: boolean,
  postalCode: string,
}

class BusinessDetailsForm extends React.Component<IProps, IState> {
  public readonly state = {
    isDisabled: false,
  }

  private requiredFieldValidation = createValidation([
    createValidator(hasRequired, this.props.getTextPath('errors.textField')),
  ])

  private contactNameValidation = createValidation([
    createValidator(hasName, this.props.getTextPath('errors.name')),
  ])

  public componentWillReceiveProps (nextProps) {
    if (this.props.isDisabled !== nextProps.isDisabled) {
      this.setState({
        isDisabled: nextProps.isDisabled,
      })
    }
  }

  public render () {
    const {
      t,
      handleSubmit,
      isEdit,
      submitting,
      isUserUnableToUpdateInfo,
      valid,
    } = this.props

    const isFieldDisabled = (isEdit && isUserUnableToUpdateInfo) || this.state.isDisabled || submitting

    return (
      <form className={styles.root} onSubmit={handleSubmit}>
        <div className={cx(styles.fieldsContainer, styles.row)}>
          <div className={styles.fieldWrap}>
            <Field
              type='text'
              name={BUSINESS_FIELD_NAMES.name}
              label={t('companyName')}
              component={Input}
              maxLength={MAX_LENGTHS.businessName}
              validate={this.requiredFieldValidation}
              size='large'
              disabled={isFieldDisabled}
              required
            />
          </div>
          <div className={styles.fieldWrap}>
            <Field
              type='text'
              name={BUSINESS_FIELD_NAMES.signatoryTitle}
              label={t('signatoryTitle')}
              component={Input}
              maxLength={MAX_LENGTHS.signatoryTitle}
              validate={this.requiredFieldValidation}
              size='large'
              disabled={isFieldDisabled}
              required
            />
          </div>
        </div>
        <div className={styles.noted}>{t('infoMessage')}</div>
        <div className={cx(styles.fieldsContainer, styles.row)}>
          <div className={styles.fieldWrap}>
            <Field
              type='text'
              name={BUSINESS_FIELD_NAMES.signatoryFirstName}
              label={t('firstName')}
              component={Input}
              maxLength={MAX_LENGTHS.name}
              validate={[this.requiredFieldValidation, this.contactNameValidation]}
              normalize={removeSpaces}
              disabled={isFieldDisabled}
              required
            />
          </div>
          <div className={styles.fieldWrap}>
            <Field
              type='text'
              name={BUSINESS_FIELD_NAMES.signatoryLastName}
              label={t('lastName')}
              component={Input}
              maxLength={MAX_LENGTHS.name}
              validate={[this.requiredFieldValidation, this.contactNameValidation]}
              normalize={removeSpaces}
              disabled={isFieldDisabled}
              required
            />
          </div>
        </div>
        {isEdit && !isUserUnableToUpdateInfo && (
          <div className={styles.submitButton}>
            <Button fluid disabled={submitting || !valid}>
              {submitting ? t('saving') : t('saveChanges')}
            </Button>
          </div>
        )}
      </form>
    )
  }
}

export default BusinessDetailsForm
